import {
  COXA_POLKU_REDIRECT_URL_ERROR,
  COXA_POLKU_REDIRECT_URL_RECEIVE,
  COXA_POLKU_REDIRECT_URL_REQUEST,
} from '../coxapolku/actions';

export const initialState = {
  data: [],
  isFetching: false,
  url: null,
  error: null,
};

export const reducer = (state, action) => {
  let { type, payload } = action;

  switch (type) {
    case COXA_POLKU_REDIRECT_URL_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case COXA_POLKU_REDIRECT_URL_RECEIVE: {
      return {
        ...state,
        url: payload,
        isFetching: false,
      };
    }
    case COXA_POLKU_REDIRECT_URL_ERROR: {
      return {
        ...state,
        error: payload,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
